/** Тексты подсказок для spotlight-тура онбординга */
export const ONBOARDING_TOUR_STEPS = {
  profile: {
    title: "Ваша секция",
    description: "Название клуба и контакты для клиентов.",
  },
  direction: {
    title: "Направление",
    description: "Вид спорта — от него зависят группы.",
  },
  venue: {
    title: "Зал",
    description: "Название и адрес площадки для занятий.",
  },
  group: {
    title: "Группы",
    description: "Направление, зал и название группы.",
  },
  schedule: {
    title: "Расписание",
    description: "Дни и время — занятия появятся в календаре.",
  },
  memberships: {
    title: "Тарифы",
    description: "Абонементы по занятиям или по сроку.",
  },
  form: {
    title: "Сохраните шаг",
    description: "Заполните форму и нажмите кнопку внизу.",
  },
};
